module.exports = __webpack_public_path__ + "static/media/import-export-arrows.3b675a0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/import-export-arrows.svg
// module id = 2034
// module chunks = 33